module.exports = __webpack_public_path__ + "img/Slice42.93f0edfd.png";